// "Abonar bono manual": monto en pesos con signo y motivo obligatorio, con los topes del motor.
import { invalidAmountMessage, pesosToCents } from './pesosInput';

export interface AdjustmentErrors {
    amount?: string;
    reason?: string;
}

const MAX_CENTS = 100_000_000;
/** El tope del motor para los motivos y las notas que quedan en la auditoría. */
export const MAX_REASON = 500;

export function validateAdjustment(amount: string, reason: string): AdjustmentErrors {
    const errors: AdjustmentErrors = {};
    const cents = pesosToCents(amount);
    if (amount.trim() === '' || cents === 0) errors.amount = 'Pon un monto distinto de 0.';
    else if (cents === null) errors.amount = invalidAmountMessage(amount);
    else if (Math.abs(cents) > MAX_CENTS) errors.amount = 'El monto no pasa de $1,000,000.';
    if (reason.trim() === '') errors.reason = 'El motivo es obligatorio: queda en la auditoría.';
    else if (reason.trim().length > MAX_REASON)
        errors.reason = 'El motivo no pasa de 500 caracteres.';
    return errors;
}
